import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { AGENCY, PRICING } from "../../data/content";

export const Pricing = () => (
  <section id="preise" className="py-24 md:py-32 px-6 md:px-12" data-testid="pricing-section">
    <div className="max-w-7xl mx-auto">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#2E5BFF] mb-4">Preise</p>
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl">
        Ein Paket, ein Festpreis. Fertig.
      </h2>
      <p className="mt-5 text-base md:text-lg text-[#9AA3AF] max-w-2xl leading-relaxed">
        Keine versteckten Kosten, kein Stundensatz-Poker. Sie wissen vorher genau, was Sie bekommen und was es kostet.
      </p>
      <div className="mt-14 grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="bg-[#171B21] border-2 border-[#2E5BFF] p-8 md:p-10 relative"
          data-testid="pricing-card-website"
        >
          <span className="absolute -top-3 left-8 text-[11px] font-bold uppercase tracking-wider bg-[#2E5BFF] text-white px-3 py-1">
            Website-Paket
          </span>
          <div className="flex items-baseline gap-2 mt-2">
            <span className="font-display text-5xl md:text-6xl font-bold">{PRICING.website.price}</span>
            <span className="text-[#9AA3AF] text-sm font-semibold">{PRICING.website.interval}</span>
          </div>
          <p className="mt-3 text-sm text-[#9AA3AF]">{PRICING.website.note}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3.5">
            {PRICING.website.features.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-[#F2F4F7]">
                <Check className="w-4 h-4 text-[#2E5BFF] mt-0.5 shrink-0" /> {f}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-[#5B6470] leading-relaxed">{PRICING.website.legal}</p>
          <a href="#kontakt" className="btn-primary px-8 py-4 text-base font-semibold inline-block mt-8" data-testid="pricing-cta">
            {AGENCY.cta}
          </a>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          className="bg-[#101318] border border-[#2A303A] p-8 md:p-10"
          data-testid="pricing-card-betreuung"
        >
          <span className="text-[11px] font-bold uppercase tracking-wider border border-[#2A303A] text-[#9AA3AF] px-3 py-1">
            Betreuung, optional
          </span>
          <div className="flex items-baseline gap-2 mt-6">
            <span className="font-display text-4xl md:text-5xl font-bold">{PRICING.care.price}</span>
            <span className="text-[#9AA3AF] text-sm font-semibold">{PRICING.care.interval}</span>
          </div>
          <p className="mt-3 text-sm text-[#9AA3AF]">{PRICING.care.note}</p>
          <ul className="mt-8 space-y-3.5">
            {PRICING.care.features.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-[#F2F4F7]">
                <Check className="w-4 h-4 text-[#2E5BFF] mt-0.5 shrink-0" /> {f}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
